import { render, staticRenderFns } from "./zhuanyoushangzuoxia.vue?vue&type=template&id=78957082&scoped=true&"
import script from "./zhuanyoushangzuoxia.vue?vue&type=script&lang=js&"
export * from "./zhuanyoushangzuoxia.vue?vue&type=script&lang=js&"
import style0 from "./zhuanyoushangzuoxia.vue?vue&type=style&index=0&id=78957082&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78957082",
  null
  
)

export default component.exports